import { ModelFilter } from "react3l-common";
import { AppUser } from "./../../models/AppUser/AppUser";
import { GLOBAL_STATE_ACTION } from "./types";

export const updateUser = (user: AppUser) => {
  return {
    type: GLOBAL_STATE_ACTION.UPDATE_USER,
    payload: user,
  };
};

export const updateSpinning = (spinning: boolean) => {
  return {
    type: GLOBAL_STATE_ACTION.UPDATE_SPINNING,
    payload: spinning,
  };
};
export const updateFilter = (filter: ModelFilter) => {
  return {
    type: GLOBAL_STATE_ACTION.UPDATE_FILTER,
    payload: filter,
  };
};
